import React from 'react'

import {Header3, Header4} from 'src/components/text'
import {Box, Flex, Grid} from 'src/components/Box'
import {GreenYellowUnderlineV3} from 'src/components/emphasis'
import {Action} from 'src/components/Action'
import {SearchTarget} from 'src/hooks/useSearch'

interface SearchContentOptionsProps {
  target: SearchTarget
  onTargetChange: (value: SearchTarget) => void
}

const SearchContentOptions = ({
  target,
  onTargetChange,
}: SearchContentOptionsProps) => (
  <>
    <Flex
      flexDirection={{default: 'column', md: 'row'}}
      justifyContent="space-between"
    >
      <Grid gridAutoFlow="column" gridGap="3">
        <SearchOptionHeader
          selected={target === SearchTarget.Algolia}
          onSelect={() => onTargetChange(SearchTarget.Algolia)}
        >
          Articles & Tools
        </SearchOptionHeader>
        <Box backgroundColor="grey2" width="3px" height="35px" />
        <SearchOptionHeader
          selected={target === SearchTarget.YouTube}
          onSelect={() => onTargetChange(SearchTarget.YouTube)}
        >
          Videos
        </SearchOptionHeader>
      </Grid>
    </Flex>
  </>
)

type SearchContentOptionHeaderProps = {
  selected: boolean
  onSelect?: () => void
  children?: React.ReactNode
}

const SearchOptionHeader = ({
  selected,
  onSelect,
  children,
}: SearchContentOptionHeaderProps) => (
  <>
    {selected ? (
      <Header4>
        <GreenYellowUnderlineV3>{children}</GreenYellowUnderlineV3>
      </Header4>
    ) : (
      <Action onClick={onSelect}>
        <Header3 color="grey5" truncate>
          {children}
        </Header3>
      </Action>
    )}
  </>
)

export default SearchContentOptions
